module.exports = __webpack_public_path__ + "static/media/30.63b7ebfb.png";